import Alpine from "alpinejs";
import "./toast.css"
/**
 * Displays a toast using the app-messages store.
 *
 * @param {Object} options
 * @param {string} [options.title='Info']        Toast title
 * @param {string} [options.message='']          Toast message
 * @param {string} [options.type='primary']      Bootstrap contextual type (mapped to category)
 * @param {number} [options.delay=3000]          Auto-hide delay (ms)
 * @param {Array}  [options.actions=[]]          Action buttons definition
 * @param {boolean}[options.modal=false]         Whether the toast behaves like a modal
 *
 * @returns {Promise<string|null>} Resolves with action id or null if dismissed
 */
export function showToast({
                              title = 'Info',
                              message = '',
                              type = 'primary',
                              delay = 3000,
                              actions = [],
                              modal = false
                          }) {
    return new Promise((resolve) => {
        Alpine.store('messages').addToast({
            title,
            message,
            category: type,
            delay,
            actions,
            modal,
            _resolve: resolve
        });
    });
}
